module.exports = __webpack_public_path__ + "5d990cfd93f3467b768a4b6fe88541d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/faction_campaign_2-320.jpg
// module id = 289
// module chunks = 0